export default "__VITE_ASSET__DPmqURVa__"